import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-outward-l2approver',
  templateUrl: './outward-l2approver.component.html',
  styleUrls: ['./outward-l2approver.component.css']
})
export class OutwardL2approverComponent implements OnInit {

  constructor(private appComponent: AppComponent) { }

  ngOnInit(): void {
  }

}
